import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/gifs/saturn.gif")